// extracted by mini-css-extract-plugin
export default {"ResizeHandleInner":"ResizeHandle_ResizeHandleInner__PWFVW","ResizeHandleOuter":"ResizeHandle_ResizeHandleOuter__RybXG","Icon":"ResizeHandle_Icon__8EbO2"};